import { Component } from '@angular/core';
import { GlobalsService } from '../../services/globals/globals.service';
import { environment } from 'src/environments/environment';

// dynamic seo test
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  public system: string;
  public lotto: number = environment.lottery.lot_id;
  constructor(private _globalService: GlobalsService) {
    this.system = this._globalService.getSystem().site;
  }
}
